import request from '@/utils/request'

let IndexApi = {

  /*基础配置*/
  base(data) {
    return request._get('/api/open/base', data);
  },

  /*商城首页*/
  getCount(data) {
    return request._post('/shop/Index/index', data);
  },
  getStatis(data) {
    return request._post('/shop/Index/getStatis', data);
  },
  getRole(data) {
    return request._post('/shop/Index/getRole', data);
  },

  /*获取处理事务*/
  visit(data) {
    return request._post('/shop/Index/visit', data);
  },
  handleVisit(data) {
    return request._post('/shop/Index/handleVisit', data);
  },


}

export default IndexApi;



// WEBPACK FOOTER //
// ./src/api/index.js